import "./triangle-divider-vertical.scss";

function TriangleDividerVertical({ extraClasses = "" }) {
  return (
    <div
      className={"triangle-divider-vertical " + extraClasses}
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/chin-vertical.png)`,
      }}
    ></div>
  );
}

export default TriangleDividerVertical;
